/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectFleetDynamicDataTrailerManual
 */
export interface MonitoredObjectFleetDynamicDataTrailerManual {
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectFleetDynamicDataTrailerManual
     */
    monitoredObjectId: string;
    /**
     * 
     * @type {Date}
     * @memberof MonitoredObjectFleetDynamicDataTrailerManual
     */
    pairedSince: Date;
}

export function MonitoredObjectFleetDynamicDataTrailerManualFromJSON(json: any): MonitoredObjectFleetDynamicDataTrailerManual {
    return MonitoredObjectFleetDynamicDataTrailerManualFromJSONTyped(json, false);
}

export function MonitoredObjectFleetDynamicDataTrailerManualFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectFleetDynamicDataTrailerManual {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': json['monitored_object_id'],
        'pairedSince': (new Date(json['paired_since'])),
    };
}

export function MonitoredObjectFleetDynamicDataTrailerManualToJSON(value?: MonitoredObjectFleetDynamicDataTrailerManual | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_id': value.monitoredObjectId,
        'paired_since': (value.pairedSince.toISOString()),
    };
}


